import { combineReducers } from 'redux';
import {
    billToAccountsReducer,
    shipToAccountsReducer,
    sessionAccountReducer,
} from './account/account-reducers';
import { apiErrorReducer, apiStatusReducer } from './api/api-status-reducer';
import {
    accountContactsReducer,
    companyAccountsReducer,
    companyBucketsReducer,
    companyRolesReducer,
} from './company/company-reducers';
import { featuredIemReducer } from './e-store/featured-item-reducers';

import { tempMessageReducer } from './e-store/temp-message-reducers';
import wishListSlice from './e-store/wish-list-slice';
import { constantsReducer } from './externals/externals.reducer';
import { OBOReducer } from './obo/obo-reducers';
import {
    cancelOrderReducer,
    deleteLineItemReducer,
    relatedItemsReducer,
    orderReducer,
    ordersReducer,
    updateBillToReducer,
    updateDeliverToReducer,
    updateShipToReducer,
    addItemsReducer,
    postEscalationReducer,
    lineItemPizzaTrackerReducer,
    reorderReducer,
    updateOptionDataReducer,
    adjustFeaturesReducer,
    selectReducer,
    orderHistoryRequestReducer,
} from './order/order-reducers';
import { orderPreferencesReducer } from './preferences/order-preferences-reducers';
import { billToShippingPreferencesReducer } from './preferences/shipping-preferences-reducers';
import { productDetailReducer } from './product/product-detail-reducers';
import { productsReducer } from './product/product-list-reducers';
import { profileReducer } from './profile/profile-reducers';
import { promoDetailsReducer } from './promo-detail/promo-detail-reducers';
import { sessionReducer } from './session/session-reducer';
import { spaPathReducer } from './spa/spa-reducers';
import { translationsReducer } from './translations/translation-reducer';
import { userReducer } from './user/user-reducers';
import { savedCartReducer } from './cart/cart-reducers';
import { cancelReasonsReducer } from './order/order-reducers';
import { deviceReducer } from './device/device-reducers';
import {
    shippingMethodsReducer,
    updateShippingMethodReducer,
} from './shipping/shipping-reducers';
import { RootState } from '../store';

const rootReducer = combineReducers({
    // reducer name should match the property name on Application State it is reducing for.
    spaPath: spaPathReducer,
    accountContacts: accountContactsReducer,
    shipToAccounts: shipToAccountsReducer,
    billToAccounts: billToAccountsReducer,
    promoDetails: promoDetailsReducer,
    order: orderReducer,
    orderHistory: ordersReducer,
    apiCallsInProgress: apiStatusReducer,
    apiCallError: apiErrorReducer,
    session: sessionReducer,
    translations: translationsReducer,
    profile: profileReducer,
    constants: constantsReducer,
    companyAccounts: companyAccountsReducer,
    companyBuckets: companyBucketsReducer,
    companyRoles: companyRolesReducer,
    currentUser: userReducer,
    obo: OBOReducer,
    featuredItems: featuredIemReducer,
    wishlists: wishListSlice,
    tempMessages: tempMessageReducer,
    orderPreferences: orderPreferencesReducer,
    productDetails: productDetailReducer,
    products: productsReducer,
    shippingPreferences: billToShippingPreferencesReducer,
    savedCart: savedCartReducer,
    cancelOrderResult: cancelOrderReducer,
    cancelReasons: cancelReasonsReducer,
    shippingMethods: shippingMethodsReducer,
    sessionAccount: sessionAccountReducer,
    deviceData: deviceReducer,
    updateShipTo: updateShipToReducer,
    updateDeliverTo: updateDeliverToReducer,
    updateDeliverToResponse: updateDeliverToReducer,
    updateShippingMethodResponse: updateShippingMethodReducer,
    updateBillTo: updateBillToReducer,
    deleteLineItemResponse: deleteLineItemReducer,
    relatedItems: relatedItemsReducer,
    addItemsResponse: addItemsReducer,
    postEscalateResponse: postEscalationReducer,
    lineItemPizzaTracker: lineItemPizzaTrackerReducer,
    reorderResult: reorderReducer,
    updateOptionData: updateOptionDataReducer,
    adjustFeaturesResponse: adjustFeaturesReducer,
    select: selectReducer,
    orderHistoryRequest: orderHistoryRequestReducer,
});

export default rootReducer;
